/** When Scout runs the job, and how long omnium waits before it checks by itself. */

import { Banner, Field, FieldRow, SchedulePicker, Select } from "@/components/kit";
import { checkSecondsFor, type Preset } from "@/lib/integrations/schedule";
import { durationWords } from "@/lib/integrations/words";

const CHECKS = [60, 300, 600, 900, 1800, 3600, 3900, 7200, 21600, 43200, 86400];

export function ScheduleStage({
  preset,
  onPreset,
  checkSeconds,
  onCheckSeconds,
  timeZone,
  sharedWith,
  scoutProblem,
}: {
  preset: Preset;
  onPreset: (preset: Preset) => void;
  checkSeconds: number;
  onCheckSeconds: (seconds: number) => void;
  timeZone: string;
  /** Other integrations that read the same Scout job. */
  sharedWith: string[];
  scoutProblem?: string | null;
}) {
  const options = [...new Set([...CHECKS, checkSeconds])].sort((a, b) => a - b);
  return (
    <div style={{ display: "grid", gap: "var(--s4)" }}>
      {scoutProblem && (
        <Banner tone="warning" title="Scout's schedule did not load.">
          {scoutProblem}
        </Banner>
      )}
      <SchedulePicker
        preset={preset}
        timeZone={timeZone}
        onChange={(next) => {
          onPreset(next);
          onCheckSeconds(checkSecondsFor(next));
        }}
      />
      {sharedWith.length > 0 && (
        <Banner tone="info">
          Scout’s schedule belongs to the job, so it also changes for {sharedWith.join(", ")}.
        </Banner>
      )}
      <FieldRow>
        <Field
          label="If nothing comes in, omnium checks Scout after"
          hint="Scout rings the doorbell when a run passes. This check is the safety net when it does not."
        >
          <Select value={checkSeconds} onChange={(event) => onCheckSeconds(Number(event.target.value))}>
            {options.map((seconds) => (
              <option key={seconds} value={seconds}>
                {durationWords(seconds)}
              </option>
            ))}
          </Select>
        </Field>
      </FieldRow>
    </div>
  );
}
